<template>
  <el-dialog title="Abertura do caixa" center :visible.sync="dialog" :before-close="close">
    <el-alert show-icon :closable="false"
      description="Caixa ainda não aberto. Informe o valor em dinheiro inicial do caixa" type="warning">
    </el-alert>
    <el-form label-width="120px">
      <el-row :gutter="5" justifty="center">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <el-form-item label="Valor:">
            <el-input type="number" :disabled="denied" :controls="false" :min="0" v-model="value"
              pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancelar</el-button>
      <el-button type="success" @click="save()">Confirmar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { PdvCashierService } from "@/services/pdv/pdv.cashier.services";
export default {
  props: ["balance"],
  data() {
    return {
      dialog: false,
      value: 0,
      denied: false,
    }
  },
  methods: {
    open(balance) {
      if (balance !== null) {
        this.value = balance;
        this.denied = true;
      }
      this.dialog = true;
    },
    close() {
      this.$message({ type: "error", duration: 5000, message: 'Para realizar os atendimentos é necessário abrir o caixa!', offset: 45 });
      this.dialog = false;
      this.$router.replace({
        name: 'pdv',
      })
    },
    save() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PdvCashierService.open(vm.value).then((response) => {
        vm.$store.commit('pdv/id', response);
        this.dialog = false;
      }).catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45 }))
        .finally(() => loading.close());

    }
  }
}
</script>

<style scoped>
.el-alert__title {
  font-size: 13px !important;
}
</style>